import { registerScope } from '@shared/lib/scope'
import { scopeRegistry } from '@app/scope/registry'

export default defineNuxtPlugin(() => {
  registerScope(scopeRegistry)
})
